/* eslint-disable react-hooks/exhaustive-deps */
import classes from './SectionMenu.module.scss';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Tooltip, Col, Row } from 'react-bootstrap';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import ViewActions from 'components/shared/views/view-actions/ViewActions';
import { CONFIGURE_VIEW, INSIGHT_TYPE, NUMBER_ZERO } from 'constants/constants';
import ViewDropdown from 'components/home/views/configure-view/ViewDropdown';
import Help from './Help';
import SaveConfirmationModal from './SaveConfirmationModal';
import LinkButton from 'components/shared/button/LinkButton';

const GlobalViewAction = () => {
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [addViewModalShow, setAddViewModalShow] = useState(false);
  const [helpModalShow, setHelpModalShow] = useState(false);
  const saveInsightViewBtnState = useSelector(
    (state) => state?.CustomerView?.saveInsightViewBtnState
  );
  const [saveModalShow, setSaveModalShow] = useState(false);
  const insightType = useSelector((state) => state?.CustomerView?.insightType);

  const isSampleInsight = insightType === INSIGHT_TYPE.SAMPLE ? true : false;

  const viewTooltip = (
    <Tooltip className='gne-tooltip'>
      <>
        Represents a view within a customer insight board. Users can create as
        many views as they need and switch between them using the downward arrow
        next to the view name. Views not only allow you to configure more tiles
        than before but also help you organize your tiles in a logical and
        streamlined way (Note: Insight Tiles are not yet enabled for Payer
        View.)
      </>
    </Tooltip>
  );

  const saveTooltip = (
    <Tooltip className='gne-tooltip'>
      <>
        Click here to save changes to your Insight board view. The button turns
        yellow when there are unsaved changes and stays greyed out if everything
        is already saved.
      </>
    </Tooltip>
  );

  const handleActionClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleHelpModalToggle = () => {
    setHelpModalShow(!helpModalShow);
  };

  const handleSaveModalToggle = () => {
    setSaveModalShow(!saveModalShow);
  };

  const handleHelpModalHide = () => {
    setHelpModalShow(false);
  };

  const handleSaveModalHide = () => {
    setSaveModalShow(false);
  };

  return (
    <>
      <div className='navbar-firstrow mx-4 mx-md-4'>
        <Row className='mb-4 '>
          {/* Left Section */}
          <Col className={`${classes['global-view-left-column']}  px-0 mx-0`}>
            {allInsightViews?.length === NUMBER_ZERO ? (
              <span>Insight Boards require a View - use 'Add New View'</span>
            ) : (
              <ViewDropdown
                viewOptions={allInsightViews}
                selectedView={selectedInsightView}
                page={CONFIGURE_VIEW?.insights}
              />
            )}
            <OverlayTrigger overlay={viewTooltip}>
              <i className={`icon icon__info__gray  p-2 mx-2  `} />
            </OverlayTrigger>
          </Col>
          {/* Right Section */}
          <Col
            className={`${classes['global-view-right-column']} ${allInsightViews?.length === NUMBER_ZERO && !isSampleInsight ? 'px-3' : 'px-0'} mx-0 text text__bold `}>
            <Row className='g-1'>
              <Col
                className={`d-flex title title__blue title__bold title__small `}
                md={3}>
                <LinkButton
                  className={'pe-0'}
                  onClick={handleHelpModalToggle}>
                  <i className={`icon icon__help_blue`} />
                  <span>Help</span>
                </LinkButton>
              </Col>
              {!isSampleInsight && (
                <>
                  <Col
                    className='d-flex title title__blue title__bold title__small px-2'
                    md={allInsightViews?.length === NUMBER_ZERO ? 6 : 5}>
                    {allInsightViews?.length === NUMBER_ZERO ? (
                      <span
                        className={`d-flex  title title__blue title__bold title__small pe-0`}>
                        <LinkButton
                          onClick={setAddViewModalShow}
                          className={'pe-0'}>
                          <span className={classes.addViewBtnText}>
                            <i className={`icon icon__add`}></i>
                            Add New View
                          </span>
                        </LinkButton>
                      </span>
                    ) : (
                      <LinkButton
                        onClick={(e) => handleActionClick(e)}
                        className={'pe-0'}>
                        <i className={`icon icon__moreAction`} />
                        <span>Actions</span>
                        <i className='icon icon__chevron-down-blue' />
                      </LinkButton>
                    )}
                  </Col>
                  <Col
                    className={`${allInsightViews?.length === NUMBER_ZERO ? 'px-0' : 'ps-2'}`}
                    md={allInsightViews?.length === NUMBER_ZERO ? 3 : 4}>
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      overlay={saveTooltip}>
                      <Button
                        onClick={handleSaveModalToggle}
                        variant={`btn-save ${
                          !selectedInsightView?.Id || saveInsightViewBtnState
                            ? ' btn-save btn-save-disabled'
                            : ' btn-save btn-save-active'
                        } d-flex align-items-center justify-content-center text text__x-small pb-1 pt-1 me-1 w-15`}
                        disabled={
                          !selectedInsightView?.Id || saveInsightViewBtnState
                        }>
                        <i
                          className={`icon ${!selectedInsightView?.Id || saveInsightViewBtnState ? 'icon__save_icon save_white' : 'icon__save_icon save_black'} pt-2 `}></i>
                        <span
                          className={`title title__bold title__small`}></span>
                        Save
                      </Button>
                    </OverlayTrigger>
                  </Col>
                </>
              )}
            </Row>
          </Col>
        </Row>
      </div>
      <div className='w-100 px-4 d-flex align-content-center'>
        <hr className={`${classes.devider}`} />
      </div>

      <ViewActions
        page={CONFIGURE_VIEW?.insights}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        currentViewRecord={selectedInsightView}
        setViewModalShow={setAddViewModalShow}
        viewModalShow={addViewModalShow}
        showAllOptions={allInsightViews?.length > 0 ? true : false}
      />
      <Help
        show={helpModalShow}
        onHide={handleHelpModalHide}
      />
      <SaveConfirmationModal
        show={saveModalShow}
        onHide={handleSaveModalHide}
      />
    </>
  );
};

export default GlobalViewAction;
